import { select, put, all, takeLatest } from 'redux-saga/effects';
import { isServerSideRendering } from '@dbh/environment';
import { DAEMON } from '@dbh/redux-extra';
import { reactRouterMatch } from '@dbh/redux-route-internals';
import { makeSelectUserLoaded, USER_LOGIN_STATUS_CHANGED } from '@dbh/user-area-redux';
import { userBookingsLoadInvoked, USER_BOOKINGS_LOAD_INVOKED, REDUX_AND_SAGA_KEY } from '@dbh/user-area-bookings-events-and-constants-redux';
import { makeSelectIsFirstPageAfterSsr, LOCATION_CHANGED_TO_SAME_LOCATION_WITHOUT_HASH } from '@dbh/routing-redux';
import { m as makeSelectUserBookingsLoadingStatus, h as handleUserBookingsLoadInvoked, a as handleShouldLoadUserBookings } from './index-cb91ac78.js';
export { u as userAreaUserBookingsChannelWatcher } from './index-cb91ac78.js';
import { PAGE_TYPES } from '@dbh/admindev-constants';
import 'reselect';
import '@dbh/generic-redux-constants';
import '@dbh/webpages-events-and-constants-redux';
import '@dbh/webpages-redux';
import '@dbh/api-constants';
import '@dbh/configuration-redux';
import '@dbh/redux-saga-extra';
import '@dbh/request-queue-redux';
import '@dbh/saga-request-options';
import '@dbh/urls';
import '@dbh/validation';
import '@dbh/request-errors';
import 'prop-types';
import 'immutable';
import 'date-fns';
import '@dbh/with-conforms-to-for-production-www';

/**
 * When the user changes location in the browser (including changing the page
 * with the paginator, in a paginated `UserReservationsPage`), if the appropriate
 * conditions are met this saga invokes the loading of the "user bookings".
 * @param {Object} event .
 * @yields {Object?} .
 */function*handleReactRouterMatchedPageType(a){if(isServerSideRendering())return;const{payload:{PAGE_TYPE:b}}=a,c=yield select(makeSelectUserLoaded()),d=yield select(makeSelectUserBookingsLoadingStatus()),e=yield select(makeSelectIsFirstPageAfterSsr());// Do not fetch if we are already fetching user bookings data.
// We do not need to fetch data that has just arrived from the server
// on the first page.
e||b!==PAGE_TYPES.UserReservationsPage||!c||d||(yield put(userBookingsLoadInvoked()));}

function*rootSaga(){yield all([takeLatest(USER_BOOKINGS_LOAD_INVOKED,handleUserBookingsLoadInvoked),takeLatest(LOCATION_CHANGED_TO_SAME_LOCATION_WITHOUT_HASH,handleShouldLoadUserBookings),takeLatest(reactRouterMatch.type,handleReactRouterMatchedPageType),...(isServerSideRendering()?[]:[takeLatest(USER_LOGIN_STATUS_CHANGED,handleShouldLoadUserBookings)])]);}const injectedSagaConfiguration={key:REDUX_AND_SAGA_KEY,saga:rootSaga,mode:DAEMON};

export { rootSaga as default, injectedSagaConfiguration };
